(function($) {

    $(document).ready(function() {


        /**
         * Menu Toggle
         */
        var menuOpen = false;
        $('.js-menu-toggle').on('click', function(evt) {
            evt.preventDefault();

            $(this).toggleClass('isOpen');
            $('.js-nav-primary').toggleClass('isOpen');
            $('.js-site-head').toggleClass('isOpen');
        });

        $('.js-menu-close').on('click', function(evt) {
            evt.preventDefault();
            closeMenu();
        });


        function closeMenu() {
            $('.js-menu-toggle').removeClass('isOpen');
            $('.js-nav-primary').removeClass('isOpen');
            $('.js-site-head').removeClass('isOpen');
        }

        $(window).resize(function(){
            closeMenu();
        });

        $('.js-nav-primary a').on('click', function(){
          closeMenu();
        });


        /*
         * Alt Header on scroll
         */
        stickHeader();
        window.addEventListener('scroll', function(e){
            stickHeader();
        });

        function stickHeader() {
            var distanceY = window.pageYOffset || document.documentElement.scrollTop,
                shrinkOn = 10,
                header = $('.js-site-head');
            if (distanceY > shrinkOn) {
                header.addClass('isSticky');

            } else {
                if (header.hasClass('isSticky')) {
                    header.removeClass('isSticky');
                }
            }
        }


        /**
         * Tabs
         */
        // $('.js-accordion-control').on('click', function(evt) {
        //     evt.preventDefault();

        //     var $tab = $(this).closest('.js-accordion-item');
        //     var $this = $(this);

        //     $tab.find('.accordion-body').toggleClass('isActive');
        //     $this.toggleClass('isActive');
        // });


        /**
         *
         * SmoothScroll
         *
         */
        // $('a[href*="#"]:not([href="#"])').click(function() {
        //     if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        //       var target = $(this.hash);
        //       target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        //       if (target.length) {
        //         $('html, body').animate({
        //           scrollTop: target.offset().top - 80
        //         }, 1000);
        //         return false;
        //       }
        //     }
        //   });





        /**
         *
         * Slick
         *
         */
        /**
         * setInitialSlide
         * Get the initial state for the Archive year slider title
         */
        function setInitialSlide() {
            var initSlide = $( '.js-archive-slick' ).slick( 'slickCurrentSlide' );
            var slide = $( '[data-slick-index="' + initSlide + '"]' ); // get current slide
            var slideYear = slide.find( '.slider__slide' ).attr( 'data-archive-year' ); // find the data attribute inside that slide
            $( '.js-archive-year' ).text( slideYear ); // update the text above to current year
        };


        enableSlick();
        $(window).resize(function() {
            setTimeout(function() {
                enableSlick();
            }, 500);
        });
        function enableSlick() {
            $('.js-slick-simple').slick();
            if (window.breakpoint !== 'mobile') {
                $('.js-slick').slick();
                $( '.js-archive-slick' ).slick();
            } else {
                if ($(".js-slick.slick-initialized").length) {
                    $('.js-slick').slick('unslick');
                }
                if ($(".js-archive-slick.slick-initialized").length) {
                    $( '.js-archive-slick' ).slick('unslick');
                }
            }
        }


        // ensure we need to run it
        if ( $( '.js-archive-slick' ).length ) {
            setInitialSlide();
        }

        $( '.js-archive-slick' ).on( 'beforeChange', function ( slick, currentSlide, nextSlide ) {
            $( '.js-archive-year' ).fadeOut(250); // hide the year when we start slide
        } );

        $( '.js-archive-slick' ).on( 'afterChange', function ( slick, currentSlide ) {
            var cs = $( '[data-slick-index="' + currentSlide.currentSlide + '"]' ); // get current slide
            var csYear = cs.find( '.slider__slide' ).attr( 'data-archive-year' ); // find the data attribute inside that slide
            $( '.js-archive-year' ).text( csYear ); // update the text above to current year
            $( '.js-archive-year' ).fadeIn(250);
        } );


        /**
         *
         * AOS int
         *
         */
        // AOS.init({
        //     offset: 200,
        //     easing: 'ease-in-out-cubic'
        // });

    });

})(jQuery); // Fully reference jQuery after this point.
